var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFearlesslyScale1 = function SvgFearlesslyScale1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 786,
    height: 507,
    fill: "none",
    viewBox: "0 0 786 507"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fearlessly-scale-1_clip0_4_33)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#fearlessly-scale-1_filter0_i_4_33)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fearlessly-scale-1_paint0_linear_4_33)",
    d: "M1712.69 569.413L1722.03 -113.831L1557.63 -48.933L1383.84 93.8431L1323.99 190.024L1272.79 200.565L1214.39 200.565L1171.12 211.381L1109.83 211.381L1032.67 200.565L979.31 200.565L911.528 181.095L793.99 163.068L673.402 171.729L569.009 171.729L467.335 230.851L415.417 221.476L297.879 251.762L152.939 268.348L37.5644 240.946L-18.4885 251.762L-18.4885 322.74L-14.9921 555.707L1712.69 569.413Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#fearlessly-scale-1_filter1_i_4_33)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fearlessly-scale-1_paint1_linear_4_33)",
    fillOpacity: 0.01,
    d: "M1713 569.413L1722.34 -113.831L1557.93 -48.933L1384.15 93.8431L1324.3 190.024L1273.1 200.565L1214.69 200.565L1171.43 211.381L1110.14 211.381L1032.98 200.565L979.619 200.565L911.836 181.095L794.298 163.068L673.71 171.729L569.318 171.729L467.644 230.851L415.725 221.476L298.187 251.762L153.248 268.348L37.873 240.946L-18.1799 251.762L-18.1799 322.74L-14.6835 555.707L1713 569.413Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fearlessly-scale-1_paint2_linear_4_33)",
    fillOpacity: 0.3,
    d: "M1712.69 569.413L1722.03 -113.831L1557.63 -48.933L1383.84 93.8431L1323.99 190.024L1272.79 200.565L1214.39 200.565L1171.12 211.381L1109.83 211.381L1032.67 200.565L979.31 200.565L911.528 181.095L793.99 163.068L673.402 171.729L569.009 171.729L467.335 230.851L415.417 221.476L297.879 251.762L152.939 268.348L37.5644 240.946L-18.4885 251.762L-18.4885 322.74L-14.9921 555.707L1712.69 569.413Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "whiteLine",
    filter: "url(#fearlessly-scale-1_filter2_i_4_33)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fearlessly-scale-1_paint3_linear_4_33)",
    fillOpacity: 0.01,
    d: "M1055.06 718.714L1064.4 35.4694L834.306 265.546L711.72 285.015L630.958 321.791L586.25 317.465L533.611 317.465L499.719 317.465L450.685 300.88L340.426 315.253L287.065 315.253L219.283 295.784L136.357 312.369L15.7688 321.029L-88.6238 321.029L-190.298 380.151L-242.216 370.777L-359.754 401.063L-504.694 417.648L-620.068 390.247L-676.121 401.063L-676.121 472.041L-672.625 705.008L1055.06 718.714Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fearlessly-scale-1_paint4_linear_4_33)",
    strokeDasharray: "8.65 8.65",
    strokeWidth: 1.442,
    d: "M813.391 98.789-8.654 98.789"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#fearlessly-scale-1_paint5_linear_4_33)",
    strokeDasharray: "8.65 8.65",
    strokeWidth: 1.442,
    d: "M813.391 297.809-8.654 297.809"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-1_paint0_linear_4_33",
    x1: 64.374,
    x2: 1685.98,
    y1: 433.874,
    y2: 298.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B2A1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#BEB7D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B91CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-1_paint1_linear_4_33",
    x1: 64.683,
    x2: 1686.29,
    y1: 433.874,
    y2: 298.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B3A2B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#C4BBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-1_paint2_linear_4_33",
    x1: 64.374,
    x2: 1685.98,
    y1: 433.874,
    y2: 298.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B48A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8BC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-1_paint3_linear_4_33",
    x1: -593.259,
    x2: 1028.35,
    y1: 583.175,
    y2: 447.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#CBB9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#C4BBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-1_paint4_linear_4_33",
    x1: 798.927,
    x2: 3.961,
    y1: 102.067,
    y2: 78.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#BDC1DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fearlessly-scale-1_paint5_linear_4_33",
    x1: 798.927,
    x2: 3.961,
    y1: 301.087,
    y2: 277.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7881B9",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fearlessly-scale-1_filter0_i_4_33",
    width: 1740.52,
    height: 686.125,
    x: -18.488,
    y: -113.831,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.885
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886275 0 0 0 0 0.894118 0 0 0 0 0.945098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4_33"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fearlessly-scale-1_filter1_i_4_33",
    width: 1740.52,
    height: 685.245,
    x: -18.18,
    y: -113.831,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.933333 0 0 0 0 0.942222 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4_33"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fearlessly-scale-1_filter2_i_4_33",
    width: 1740.52,
    height: 685.245,
    x: -676.121,
    y: 35.469,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.933333 0 0 0 0 0.942222 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4_33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fearlessly-scale-1_clip0_4_33"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H786V507H0z"
  })))));
};
export default SvgFearlesslyScale1;